import Riepilogo from 'components/riepilogo';
import Text from 'components/text';
import { userInfo } from 'pages/admin/_redux/actions';
import { userInfoSelector } from 'pages/admin/_redux/selectors';
import React, { useEffect, useState } from 'react';
import { Button, Col, OverlayTrigger, Popover, PopoverContent, Row } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import logo from '../../assets/images/logo.png';

const mapBreadcrumb: { [key: string]: string } = {
  'dashboard': 'Dashboard',
  'cruscotto-campagne': 'Dashboard campagne',
  'ricerca': 'Ricerca',
  'ricerca-anagrafe-cedacri': 'Anagrafe Cedacri',
  'campagne': 'Campagne',
  'log-certificazioni-infocenter': 'Log certificazioni infocenter',
  'log-tracciato-infocenter': 'Log tracciato infocenter'
}

const mapKeyBreadcrumb: { [key: string]: string }[] = [
  {
    'ricerca': 'NDG',
    'campagne': 'Campagna'
  },
  {
    'ricerca': 'Certificazione'
  }
];

const Header: React.FC = () => {

  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const userInfoDto = useAppSelector(userInfoSelector);
  const [breadcrumb, setBreadcrumb] = useState<string[]>([]);

  useEffect(() => {
    dispatch(userInfo());
  }, [dispatch]);

  useEffect(() => {
    const paths = pathname.split("/");
    if (paths.length > 1) {
      setBreadcrumb(paths.slice(2));
    } else {
      setBreadcrumb([]);
    }
  }, [pathname]);

  const getVoceBreadcrumb = (i: number): string => {
    if (i > 0) {
      return mapKeyBreadcrumb[i - 1][breadcrumb[0]] + ' ' + breadcrumb[i];
    } else {
      return mapBreadcrumb[breadcrumb[i]] || breadcrumb[i];
    }
  };

  const onBreadcrumbClick = (index: number) => {
    history.go(-(breadcrumb.length - 1 - index));
  };

  const popover = (
    <Popover id="popover-basic">
      <PopoverContent>
        <Row>
          <Col md={12}>
            <Riepilogo chiave="Matricola" valore={userInfoDto?.matricola} />
          </Col>
          <Col md={12}>
            <Riepilogo chiave="Cod. Filiale" valore={userInfoDto?.codiceFiliale} />
          </Col>
          <Col md={12}>
            <Riepilogo chiave="Ruolo" valore={userInfoDto?.tipoProfilo} />
          </Col>
        </Row>
      </PopoverContent>
    </Popover>
  );

  return (
    <>
      <div className="header fixed">
        <div className="container-fluid">
          <Row>
            <Col sm="auto">
              <div className="d-flex align-items-center">
                <img alt="Logo Desio" src={logo} height={60} style={{ paddingRight: 8 }} />
                <Text title="Desio - Certificazione contatti" type='titolo' />
              </div>
            </Col>
            <Col className="d-flex justify-content-end  align-items-center">
              <OverlayTrigger trigger="click" placement="bottom-end" overlay={popover}>
                {({ ref, ...triggerHandler }) => (
                  <Button ref={ref} {...triggerHandler} variant="link">{userInfoDto?.nominativo} <i className="fas fa-caret-down"></i></Button>
                )}
              </OverlayTrigger>
            </Col>
          </Row>
        </div>
      </div>
      <Breadcrumb>
        {
          breadcrumb.map((bread: string, i: number) => (
            <Breadcrumb.Item key={'bread_' + i} active={i === breadcrumb.length - 1} onClick={i === breadcrumb.length - 1 ? undefined : () => onBreadcrumbClick(i)}>
              {getVoceBreadcrumb(i)}
            </Breadcrumb.Item>
          ))
        }
      </Breadcrumb>
    </>

  );

}


export default Header;
